module.exports = __webpack_public_path__ + "img/achievements.d3e6bfd7.png";